'use client';
import { jsx } from 'react/jsx-runtime';
import { ValidationMessage } from '../../validation-message/validation-message.js';

const ComboboxError = ({ size, error, formFieldProps }) => {
    return (jsx("div", { className: 'ds-combobox__error-message', id: formFieldProps.errorId, "aria-live": 'polite', "aria-relevant": 'additions removals', children: error && jsx(ValidationMessage, { "data-size": size, children: error }) }));
};
ComboboxError.displayName = 'ComboboxError';

export { ComboboxError as default };
